type AuthenticationEventData = {
    authenticated: boolean;
};

export function triggerSuccessfulAuthentication() {
    // The CustomEvent construction syntax is not used here because we
    // support Internet Explorer. See https://caniuse.com/customevent.

    const event: CustomEvent<AuthenticationEventData> = document.createEvent(
        'CustomEvent'
    );

    event.initCustomEvent('authentication', false, false, {
        authenticated: true
    });

    window.dispatchEvent(event);
}
